module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_background_image5.be35349c.svg";